import React from 'react';
import {Form, Input, Button, Card} from 'antd';
import {modifyPassword} from '../../service/home';
import {openNotice, config} from 'Utils';
import {newPasswordNotSameValidator, passwordStrengthValidator} from '../../utils/regexp.js';

const FormItem = Form.Item;

class ForcedChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkPass2 = this.checkPass2.bind(this);
        this.checkNewPwd = this.checkNewPwd.bind(this);
    }

    checkNewPwd(rule, value, callback) {
        newPasswordNotSameValidator(() => this.props.form.getFieldValue('originPwd'))(rule, value, (err) => {
            if (err) {
                callback(err);
                return;
            }
            passwordStrengthValidator(rule, value, callback);
        });
    }

    checkPass2(rule, value, callback) {
        const {getFieldValue} = this.props.form;
        if (value && value !== getFieldValue('newPwd')) {
            callback('两次输入密码不一致！');
        } else {
            callback();
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }
            modifyPassword({
                oldPassword: values.originPwd.toUpperCase(),
                newPassword: values.newPwd.toUpperCase(),
            }).then(result => {
                if (result && result.code == 200) {
                    const user = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
                    user.enforcedChangePasswd = false;
                    window.localStorage.setItem('login_user_information', JSON.stringify(user));
                    openNotice('success', '修改密码成功');
                    window.location.href = `#${config.h5Root}`;
                } else {
                    openNotice('error', '修改密码失败', (result && result.message) ? result.message : '');
                }
            });
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 7},
            wrapperCol: {span: 14},
        };
        return (
            <div style={{padding: '40px 20px', background: '#f0f2f5', minHeight: '100vh'}}>
                <Card
                    title="修改密码"
                    style={{maxWidth: 520, margin: '0 auto'}}
                >
                    <p style={{marginBottom: 24, color: '#f5222d'}}>
                        您的账号需要修改密码后才能继续使用系统，请先完成密码修改。
                    </p>
                    <p style={{marginBottom: 24, color: '#666'}}>
                        密码须至少6位，同时包含字母和数字，且不能包含连续数字（如12345、54321），不能与原密码相同。
                    </p>
                    <Form layout="horizontal" onSubmit={this.handleSubmit}>
                        <FormItem label="请输入原密码" {...formItemLayout}>
                            {getFieldDecorator('originPwd', {
                                rules: [{
                                    required: true,
                                    message: '请输入原密码',
                                }],
                            })(
                                <Input type="password" placeholder="请输入原密码"/>
                            )}
                        </FormItem>
                        <FormItem label="请输入新密码" {...formItemLayout}>
                            {getFieldDecorator('newPwd', {
                                rules: [{
                                    required: true,
                                    message: '请输入新密码',
                                }, {
                                    validator: this.checkNewPwd,
                                }],
                            })(
                                <Input type="password" placeholder="请输入新密码"/>
                            )}
                        </FormItem>
                        <FormItem label="请再次输入新密码" {...formItemLayout}>
                            {getFieldDecorator('newPwd2', {
                                rules: [{
                                    required: true,
                                    message: '密码长度最少6位',
                                    min: 6,
                                }, {
                                    validator: this.checkPass2,
                                }],
                            })(
                                <Input type="password" placeholder="请再次输入新密码"/>
                            )}
                        </FormItem>
                        <FormItem wrapperCol={{span: 14, offset: 7}}>
                            <Button type="primary" htmlType="submit">确认修改</Button>
                        </FormItem>
                    </Form>
                </Card>
            </div>
        );
    }
}

export default Form.create()(ForcedChangePassword);



// WEBPACK FOOTER //
// ./src/routes/profile/forcedChangePassword.js